// All Services content for Bloc & Brush

export const SERVICE_DETAILS = [
  {
    slug: "interior-fit-out",
    eyebrow: "01",
    title: "Interior Fit-Out",
    short:
      "Complete turnkey fit-outs — civil works, gypsum, joinery, glass, lighting and finishes — delivered by one team.",
    image:
      "https://images.pexels.com/photos/34688219/pexels-photo-34688219.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
    intro:
      "Bloc & Brush transforms empty shells and tired interiors into fully functional, beautifully finished spaces. Every fit-out is delivered with a single dedicated team — from civil works through to the final coat of paint — using engineered processes, premium materials and meticulous quality control. We work across luxury villas, apartments, offices, restaurants, retail, clinics and hospitality, coordinating every trade in-house so clients never juggle subcontractors. The result: predictable timelines, transparent costs and finishes worthy of Dubai's most prestigious addresses.",
    groups: [
      { h: "Civil Works", items: ["Demolition", "Block Work", "Concrete Works", "Structural Modifications", "Waterproofing", "Masonry"] },
      { h: "Gypsum Works", items: ["False Ceilings", "Decorative Ceilings", "Bulkheads", "Partitions", "Acoustic Systems"] },
      { h: "Painting & Finishes", items: ["Interior Painting", "Exterior Painting", "Decorative Paint", "Wallpaper", "Feature Walls", "Microcement"] },
      { h: "Flooring", items: ["Marble", "Tiles", "SPC", "Vinyl", "Wooden Flooring", "Laminate", "Epoxy"] },
      { h: "Joinery", items: ["Wardrobes", "Kitchen Cabinets", "Media Walls", "Reception Counters", "Display Units", "Doors"] },
      { h: "Glass Works", items: ["Glass Partitions", "Shower Enclosures", "Mirrors", "Balustrades"] },
      { h: "Lighting", items: ["LED", "Cove Lighting", "Spotlights", "Decorative Lighting"] },
      { h: "Renovation", items: ["Kitchen Renovation", "Bathroom Renovation", "Outdoor Works", "Landscaping", "Pergolas", "Decking", "Boundary Walls"] },
    ],
    cta: "Book a Site Visit",
  },
  {
    slug: "holiday-home-furnishing",
    eyebrow: "02",
    title: "Holiday Home Furnishing",
    short:
      "Complete Airbnb-ready packages — furniture, decor, appliances, styling and inventory — delivered in days, not months.",
    image:
      "https://images.unsplash.com/photo-1616594039964-ae9021a400a0?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    intro:
      "Bloc & Brush transforms empty apartments and villas into premium Airbnb-ready properties optimised for higher occupancy, better reviews and stronger rental income. Our furnishing team manages everything: furniture sourcing, mattresses, curtains, media walls, kitchen equipment, artwork, accessories and complete guest setup. Every detail is selected to feel cohesive, photogenic and guest-ready from day one. Owners receive a fully styled, inventory-listed property with professional photography coordination — generating bookings the moment doors open.",
    groups: [
      { h: "Furnishing", items: ["Furniture", "Mattresses", "Curtains", "Media Walls", "Appliances", "Kitchen Equipment", "Lighting", "Decor"] },
      { h: "Guest Experience", items: ["Accessories", "Artwork", "Guest Setup", "Inventory Listing", "Styling", "Professional Photography Coordination"] },
      { h: "Benefits", items: ["Higher Occupancy", "Higher Rental Income", "Professional Guest Experience", "Quick Project Delivery", "One Turnkey Solution"] },
    ],
    cta: "Explore Holiday Home Furnishing",
  },
  {
    slug: "mep-services",
    eyebrow: "03",
    title: "MEP Services",
    short:
      "Mechanical, Electrical and Plumbing engineering — designed, installed, tested and commissioned to authority standards.",
    image:
      "https://images.unsplash.com/photo-1698479603408-1a66a6d9e80f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    intro:
      "MEP is the hidden backbone of every successful property. Bloc & Brush delivers fully engineered Mechanical, Electrical and Plumbing systems that are safe, efficient and built to last. Our certified specialists design, install, test and commission systems that comply with Dubai authority standards — from luxury apartments and offices to restaurants and clinics. Properly executed MEP improves operating costs, asset value, occupant comfort and life safety; we deliver all of it under one coordinated team.",
    groups: [
      { h: "Electrical", items: ["Lighting", "Power", "Distribution Boards", "Emergency Lighting"] },
      { h: "Mechanical", items: ["HVAC", "Ventilation", "VRF", "Package Units", "Fresh Air"] },
      { h: "Plumbing", items: ["Water Supply", "Drainage", "Water Heaters", "Leak Detection"] },
      { h: "ELV Systems", items: ["CCTV", "Access Control", "Networking", "Intercom"] },
      { h: "Safety & Handover", items: ["Fire Alarm", "Testing & Commissioning"] },
    ],
    cta: "Discuss Your Project",
  },
  {
    slug: "facility-maintenance",
    eyebrow: "04",
    title: "Facility Maintenance",
    short:
      "Preventive maintenance and emergency response that protects your property and asset value year-round.",
    image:
      "https://images.unsplash.com/photo-1581092160562-40aa08e78837?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    intro:
      "Regular, professional maintenance is the single biggest factor in protecting a property's long-term value. Bloc & Brush offers Annual Maintenance Contracts and on-demand response across electrical, plumbing, HVAC, carpentry, handyman and finishing trades. Our technicians arrive in branded uniforms, with proper tools and a structured checklist — restoring small issues before they become expensive failures. Whether you own a single apartment, a portfolio of holiday homes or a commercial building, we keep everything performing as designed.",
    groups: [
      { h: "Contracts", items: ["Preventive Maintenance", "Annual Maintenance Contracts", "Emergency Response"] },
      { h: "Trades", items: ["Electrical Repairs", "Plumbing", "AC Maintenance", "Painting", "Carpentry", "Handyman"] },
      { h: "Finishing & Repairs", items: ["Door Repairs", "Lock Replacement", "Silicone", "Tile Repairs", "Leak Repairs"] },
    ],
    cta: "Schedule Maintenance",
  },
  {
    slug: "professional-cleaning",
    eyebrow: "05",
    title: "Professional Cleaning",
    short:
      "Steam, deep, post-construction and specialty cleaning — trained teams, eco-friendly chemicals, fixed transparent pricing.",
    image:
      "https://images.pexels.com/photos/6197108/pexels-photo-6197108.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
    intro:
      "Bloc & Brush operates one of Dubai's most professional cleaning divisions — engineered around steam extraction, eco-friendly chemistry and trained, uniformed teams. We handle deep cleans, move-in/move-out, post-construction, holiday home turnovers, sanitisation and specialty fabric care. Every job uses commercial-grade equipment, fabric-safe products and a quality checklist that's signed off before our team leaves. Pricing is fixed and published — no surprises, no upselling, just visible results.",
    groups: [
      { h: "Cleaning Types", items: ["Villa Cleaning", "Apartment Cleaning", "Office Cleaning", "Move In Cleaning", "Move Out Cleaning", "Post Construction Cleaning", "Holiday Home Cleaning"] },
      { h: "Deep & Specialty", items: ["Deep Cleaning", "Steam Cleaning", "Sanitization", "Disinfection"] },
      { h: "Method", items: ["Steam Extraction", "Fabric Safe Products", "Dust Mite Removal", "Odour Removal", "Fast Drying", "Eco-Friendly Chemicals", "Professional Equipment"] },
    ],
    cta: "Book Cleaning Today",
  },
  {
    slug: "authority-approvals",
    eyebrow: "06",
    title: "Authority Approvals",
    short:
      "Permits and approvals coordinated end-to-end — Dubai Municipality, DDA, DCD, DEWA, Trakhees, Nakheel, Emaar and more.",
    image:
      "https://images.unsplash.com/photo-1721244654394-36a7bc2da288?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    intro:
      "Every construction or renovation project in Dubai requires authority approvals before works begin. Bloc & Brush coordinates the full approval process on behalf of clients — preparing technical drawings, submitting documents, attending inspections and securing the permits required for legal, safe and insurable works. Our team has long-standing relationships with the major Dubai authorities and free zones, which means faster turnarounds, fewer rejections and a single point of accountability throughout.",
    groups: [
      { h: "Authorities", items: ["Dubai Municipality", "DEWA", "DDA", "DCD", "RTA", "Nakheel", "Emaar", "Trakhees", "Dubai South"] },
      { h: "We Handle", items: ["Drawing Preparation", "Document Submission", "NOC Coordination", "Inspections", "Permit Closure"] },
    ],
    cta: "Talk to Our Team",
  },
  {
    slug: "project-management",
    eyebrow: "07",
    title: "Project Management",
    short:
      "Dedicated project managers coordinating design, procurement, trades, approvals and handover — with a single point of accountability.",
    image:
      "https://images.unsplash.com/photo-1521737604893-d14cc237f11d?auto=format&fit=crop&w=1600&q=85",
    intro:
      "Every Bloc & Brush project is assigned a dedicated project manager responsible for delivery from first meeting to final handover. That single point of accountability means clear communication, controlled costs and disciplined execution — regardless of whether we're delivering a two-bedroom refit or a full commercial fit-out. Our PMs run structured weekly reports, milestone-based payment schedules, procurement tracking and quality gates so nothing slips.",
    groups: [
      { h: "Planning & Control", items: ["Scope Definition", "Programme & Milestones", "Cost Control", "Risk Register"] },
      { h: "Coordination", items: ["Design Coordination", "MEP & Civil Coordination", "Trade Sequencing", "Authority Liaison"] },
      { h: "Reporting", items: ["Weekly Progress Reports", "Photo Documentation", "Change Control", "Snag & Punch Lists"] },
      { h: "Delivery", items: ["Procurement Tracking", "Quality Gates", "Handover Packs", "As-Built Records"] },
    ],
    cta: "Talk to a Project Manager",
  },
];

export const CLEANING_PRICING = [
  {
    title: "Sofa Cleaning",
    rows: [
      ["Single Sofa", "AED 40"],
      ["2 Seater", "AED 70"],
      ["3 Seater", "AED 105"],
      ["4 Seater", "AED 140"],
      ["5 Seater", "AED 175"],
      ["Dining Chair", "AED 20"],
    ],
  },
  {
    title: "Carpet Cleaning",
    rows: [
      ["Small", "AED 100"],
      ["Medium", "AED 130"],
      ["Large", "AED 170"],
      ["Extra Large", "AED 220"],
    ],
  },
  {
    title: "Mattress Cleaning",
    rows: [
      ["Single", "AED 90"],
      ["Double", "AED 110"],
      ["Queen", "AED 130"],
      ["King", "AED 160"],
    ],
  },
  {
    title: "Curtain Cleaning",
    rows: [
      ["Small", "AED 100"],
      ["Medium", "AED 130"],
      ["Large", "AED 170"],
    ],
  },
];

export const SERVICES_INDUSTRIES = [
  { label: "Luxury Villas", img: "https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?auto=format&fit=crop&w=1200&q=80" },
  { label: "Apartments", img: "https://images.unsplash.com/photo-1493809842364-78817add7ffb?auto=format&fit=crop&w=1200&q=80" },
  { label: "Holiday Homes", img: "https://images.unsplash.com/photo-1616594039964-ae9021a400a0?auto=format&fit=crop&w=1200&q=80" },
  { label: "Hotels", img: "https://images.unsplash.com/photo-1455587734955-081b22074882?auto=format&fit=crop&w=1200&q=80" },
  { label: "Restaurants", img: "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?auto=format&fit=crop&w=1200&q=80" },
  { label: "Retail", img: "https://images.unsplash.com/photo-1441986300917-64674bd600d8?auto=format&fit=crop&w=1200&q=80" },
  { label: "Corporate Offices", img: "https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=1200&q=80" },
  { label: "Clinics", img: "https://images.unsplash.com/photo-1629909613654-28e377c37b09?auto=format&fit=crop&w=1200&q=80" },
  { label: "Warehouses", img: "https://images.unsplash.com/photo-1553413077-190dd305871c?auto=format&fit=crop&w=1200&q=80" },
  { label: "Schools", img: "https://images.unsplash.com/photo-1580582932707-520aed937b7b?auto=format&fit=crop&w=1200&q=80" },
  { label: "Property Developers", img: "https://images.unsplash.com/photo-1582407947304-fd86f028f716?auto=format&fit=crop&w=1200&q=80" },
  { label: "Facility Management", img: "https://images.unsplash.com/photo-1581092160562-40aa08e78837?auto=format&fit=crop&w=1200&q=80" },
];

export const SERVICES_FAQ = [
  { q: "Do you provide turnkey interior fit-out services in Dubai?", a: "Yes. Bloc & Brush delivers complete turnkey fit-outs covering design coordination, authority approvals, civil works, MEP, joinery, painting, finishes and final handover — all under one team and one contract." },
  { q: "Can you handle authority approvals on our behalf?", a: "Absolutely. We coordinate approvals with Dubai Municipality, DEWA, DDA, DCD, RTA, Trakhees, Nakheel, Emaar and Dubai South — preparing drawings, submitting documents and managing inspections through to permit closure." },
  { q: "How long does a typical apartment fit-out take?", a: "Most apartment fit-outs range from 4 to 10 weeks depending on scope. Villas and commercial projects vary based on size and complexity. We provide a clear timeline with milestones inside every quotation." },
  { q: "Do you offer Annual Maintenance Contracts (AMC)?", a: "Yes. Our AMCs cover preventive maintenance and on-call repairs across electrical, plumbing, HVAC, carpentry and finishing trades — for villas, apartments, holiday homes and commercial properties." },
  { q: "Is your cleaning pricing fixed?", a: "Yes. Our sofa, carpet, mattress and curtain cleaning are published with fixed transparent pricing on this page. Larger or specialty jobs receive a written quotation in advance." },
  { q: "What chemicals do you use for cleaning?", a: "We use eco-friendly, fabric-safe and family-safe chemicals along with steam extraction. All products are tested to be safe around children, pets and sensitive fabrics." },
  { q: "Can you furnish a holiday home end-to-end?", a: "Yes. Our holiday home package covers furniture, mattresses, curtains, media walls, kitchen equipment, decor, artwork, inventory listing and professional photography coordination — typically completed in 2 to 3 weeks." },
  { q: "Are your MEP works compliant with Dubai authorities?", a: "Every Bloc & Brush MEP installation follows Dubai authority codes (DEWA, DCD, ETISALAT, Dubai Municipality). Our technicians are certified and our works pass authority testing and commissioning." },
  { q: "Do you provide warranty on your work?", a: "Yes. All fit-out, MEP and waterproofing works include a written workmanship warranty. Specific durations are outlined inside each project contract." },
  { q: "Do you use premium materials?", a: "We work with leading regional and international suppliers across joinery, marble, tiles, sanitaryware, paints and lighting. Material samples are presented and approved before procurement." },
  { q: "Can you work on occupied properties or holiday homes between bookings?", a: "Yes. We schedule works around occupancy — including short windows between guest check-outs and check-ins for holiday home operators." },
  { q: "Do you handle emergency leaks and water damage?", a: "Yes. Our facility maintenance team responds to leaks, water damage and emergency plumbing across Dubai. Leak investigation is followed by a permanent waterproofing solution." },
  { q: "What is the minimum project size you accept?", a: "We accept everything from a single mattress cleaning to a full villa renovation. No project is too small or too large for our team." },
  { q: "Do you offer post-construction cleaning?", a: "Yes. Post-construction cleaning is one of our specialties — we remove dust, paint, silicone, adhesives and debris using commercial equipment and eco-friendly chemistry." },
  { q: "Can I get a fixed-price quotation?", a: "For defined scopes we provide fixed-price quotations. For variable scopes we provide unit rates and a clear allowance, with no hidden costs." },
  { q: "Do you provide design services?", a: "Yes. Our in-house team handles design coordination including layouts, material selections and finishing specifications. We also partner with leading Dubai designers when required." },
  { q: "Which areas in Dubai do you serve?", a: "We serve the entire Dubai emirate — Downtown, Marina, Palm Jumeirah, Business Bay, JBR, Arabian Ranches, MBR City, Jumeirah, JVC, JVT, Dubai Hills, DIFC, Emirates Hills and all major communities." },
  { q: "Do you accept card and online payments?", a: "Yes. We accept bank transfer, card and online payment links. Project payments follow a milestone schedule defined inside the contract." },
  { q: "Can you provide references from past projects?", a: "Yes. Once we understand your project scope, we share relevant references and a curated case study deck of similar completed projects." },
  { q: "How do I get started?", a: "Click Get Free Quote or message us on WhatsApp. A project consultant will respond within 24 hours to schedule a site visit and prepare a written proposal." },
];

export const WHY_CHOOSE = [
  "One Contractor",
  "Turnkey Solutions",
  "Experienced Professionals",
  "Transparent Pricing",
  "Quality Materials",
  "Long-Term Support",
  "Aftercare Services",
  "Dubai Based",
];

export const SERVICES_PROCESS = [
  "Consultation",
  "Site Survey",
  "Quotation",
  "Design & Planning",
  "Execution",
  "Quality Inspection",
  "Handover",
  "Ongoing Support",
];
